import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const UniversalAssociationsSelectOptionHeader = ({
  pluralObjectName
}) => {
  return /*#__PURE__*/_jsx(Text, {
    typography: "heading-50",
    "data-unit-test": `${pluralObjectName}-associations-option-header`,
    children: pluralObjectName
  });
};
export default UniversalAssociationsSelectOptionHeader;